// side effect: fetch new price calculation when decisions are made
import {ChoiceValueDecisionState} from '@viamedici-spc/configurator-ts';

import {fetchPrice} from '../slices/priceSlice';
import {selectSpcSession} from '../selectors';
import {storeConfiguration} from '../slices/configurationSlice';

export const priceMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === 'spc/spcStoreConfiguration' && action.payload?.instance === 'default') {

		// get default spc session
		const spcSession = selectSpcSession(store.getState());
		const spcConfiguration = spcSession?.getConfiguration();

		if (spcSession && spcConfiguration?.isSatisfied) {
            // after decision(s), get the new prices
			const decisions = spcSession.getDecisions();

			// current date in format 2025-06-01T12:00:00
			const datetime = new Date().toISOString().slice(0, 19);

            store.dispatch(fetchPrice({
				datetime: datetime,
                features: decisions
                    .filter(attribute => attribute.state === ChoiceValueDecisionState.Included)
                    .map(attribute => ({
                            featureId: attribute.attributeId.localId,
                            valueId: attribute.choiceValueId
                        })
                    )
            }));
        }
    }
    return result;
};
